export const ZOOM_MIN = 0.3;
export const ZOOM_MAX = 1.6;
export const ZOOM_STEP = 0.05;

// Side menus follow one quarter of the canvas zoom change.
export const sideMenuZoom = (scale) => 1 + (scale - 1) * 0.25;

export const DEFAULT_DISPLAY_SETTINGS = Object.freeze({
  scale: 1,
  density: 'standard',
  minimapAlwaysVisible: false,
});

const VALID_DENSITIES = new Set(['compact', 'standard', 'comfortable']);

export const normalizeDisplaySettings = (settings = {}) => {
  const requestedScale = Number(settings.scale);
  const scale = Number.isFinite(requestedScale)
    ? Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(requestedScale / ZOOM_STEP) / 20))
    : DEFAULT_DISPLAY_SETTINGS.scale;
  const density = VALID_DENSITIES.has(settings.density)
    ? settings.density
    : DEFAULT_DISPLAY_SETTINGS.density;
  const minimapAlwaysVisible = settings.minimapAlwaysVisible === true;

  return { scale, density, minimapAlwaysVisible };
};

export const readDisplaySettings = (storage, key) => {
  try {
    const saved = storage?.getItem(key);
    return saved
      ? normalizeDisplaySettings(JSON.parse(saved))
      : { ...DEFAULT_DISPLAY_SETTINGS };
  } catch (error) {
    return { ...DEFAULT_DISPLAY_SETTINGS };
  }
};
